import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { digitalOptionCost, smallPrintCost, bigPrintCost } from '../utils/prices';
//import { siteUrl } from '../utils/auth';

export default function Card({
  card,
  onImageClick,
  onDownloadOption,
  onYearbookOption,
  onHandleConfirmDeleteCard,
  onHandleAvatarChange,
  onSmallPrintClickUp,
  onSmallPrintClickDown,
  onBigPrintClickUp,
  onBigPrintClickDown,
}) {
 
  const [imageClass, setImageClass] = useState(''); // New state for image class
  const currentUser = useSelector((state) => state.user.currentUser);

  // Function to handle image load and determine class based on aspect ratio
  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;
    if (naturalWidth > naturalHeight) {
      setImageClass('landscape');
    } else {
      setImageClass('portrait');
    }
  };

  const handleImageClick = () => onImageClick(card);
  const handleAvatarChange = () => {
  onHandleAvatarChange({ avatar: card.link });
  };
  const handleConfirmDeleteCard = () => onHandleConfirmDeleteCard(card);
  const handleDownloadOptionClick = () => onDownloadOption(card);
  const handleYearbookOptionClick = () => onYearbookOption(card);
  const handleSmallPrintClickUp = () => onSmallPrintClickUp(card);
  const handleSmallPrintClickDown = () => onSmallPrintClickDown(card);
  const handleBigPrintClickUp = () => onBigPrintClickUp(card);
  const handleBigPrintClickDown = () => onBigPrintClickDown(card);

  const isDownloadOption = card.downloadOption === true;
  const isYearbookOption = card.yearbookOption === true;

  const downloadOptionButtonClass = (`element__heart-btn ${isDownloadOption && 'element__heart-btn_active'}`);
  const yearbookOptionButtonClass = (`element__heart-btn ${isYearbookOption && 'element__heart-btn_active'}`);

  return (
    <article className='element'>
      <button type='button' className='element__trash-btn' onClick={handleConfirmDeleteCard} />
      <button type='button' className='element__avatar-btn' onClick={handleAvatarChange} />
      <img 
        className={`element__image ${imageClass}`} 
        alt={card.name} 
        src={card.link} 
        onLoad={handleImageLoad} 
        onClick={handleImageClick} 
      />
      {currentUser?.isYearbookTeamMember ? (
        <div className='element__options'>
          <h2 className='element__title'>{card.name}</h2>
          <div className='element__title'>{card.ownerName}</div>
          <div className='element__title'>{card.about}</div>
        </div>
      ) : (
        <div className='element__options'>
          <h2 className='element__title'>{card.name}</h2>
          {!card.isClassPhoto ? (
            <>
              <div className='element__option'>
                Use for Yearbook (free) <button type='button' className={yearbookOptionButtonClass} onClick={handleYearbookOptionClick} />
              </div>
              <div className='element__option'>
                Download ({digitalOptionCost} RUB) <button type='button' className={downloadOptionButtonClass} onClick={handleDownloadOptionClick} />
              </div>
              <div className='element__option'>
                Print 10×15 cm ({smallPrintCost} RUB)
                <div className='element__print-counter-group'>
                  <button
                    type='button'
                    className='element__print-down'
                    onClick={handleSmallPrintClickDown}
                    disabled={card.smallPrintCounter === 0}>
                  </button>
                  <span className='element__print-counter'>{!card.smallPrintCounter ? 0 : card.smallPrintCounter}</span>
                  <button
                    type='button'
                    className='element__print-up'
                    onClick={handleSmallPrintClickUp}
                    disabled={card.smallPrintCounter === 10}
                  ></button>
                </div>
              </div>
            </>
          ) : (
            <div className='element__option'>
              Class photo is available as a large format print only
            </div>
          )}
          <div className='element__option'>
            Print 20×30 cm ({bigPrintCost} RUB)
            <div className='element__print-counter-group'>
              <button
                type='button'
                className='element__print-down'
                onClick={handleBigPrintClickDown}
                disabled={card.bigPrintCounter === 0}>
              </button>
              <span className='element__print-counter'>{!card.bigPrintCounter ? 0 : card.bigPrintCounter}</span>
              <button
                type='button'
                className='element__print-up'
                onClick={handleBigPrintClickUp}
                disabled={card.bigPrintCounter === 10}
              ></button>
            </div>
          </div>
        </div>
      )}
    </article>
  );
}
